import { RunSettingsHandler } from './level/RunSettingsHandler';
import { Player } from './Player';

export interface PlayerControls {
  jump: Phaser.Input.Keyboard.Key;
  jumpSecond: Phaser.Input.Keyboard.Key;
  switch: Phaser.Input.Keyboard.Key;
  switchSecond: Phaser.Input.Keyboard.Key;
  speedUp: Phaser.Input.Keyboard.Key;
  speedDown: Phaser.Input.Keyboard.Key;
}

export interface DebugPlayerControls {
  toggleDebugMovement: Phaser.Input.Keyboard.Key;
  up: Phaser.Input.Keyboard.Key;
  upSecond: Phaser.Input.Keyboard.Key;
  down: Phaser.Input.Keyboard.Key;
  downSecond: Phaser.Input.Keyboard.Key;
  left: Phaser.Input.Keyboard.Key;
  leftSecond: Phaser.Input.Keyboard.Key;
  right: Phaser.Input.Keyboard.Key;
  rightSecond: Phaser.Input.Keyboard.Key;
  jumpReset: Phaser.Input.Keyboard.Key;
  autoRun: Phaser.Input.Keyboard.Key;
}

export class PlayerController {
  public static events = {
    StartJump: 'startJump',
    EndJump: 'endJump',
    Switch: 'switch'
  } as const;

  protected scene: Phaser.Scene;
  protected player: Player;

  protected playerControls: PlayerControls;
  protected debugControls: DebugPlayerControls;

  protected allowDebugControls: boolean;
  protected allowDebugMovement: boolean;

  constructor(scene: Phaser.Scene, player: Player) {
    this.scene = scene;
    this.player = player;

    this.playerControls = this.scene.input.keyboard.addKeys({
      jump: Phaser.Input.Keyboard.KeyCodes.SPACE,
      jumpSecond: Phaser.Input.Keyboard.KeyCodes.W,
      switch: Phaser.Input.Keyboard.KeyCodes.ENTER,
      switchSecond: Phaser.Input.Keyboard.KeyCodes.E,
      speedUp: Phaser.Input.Keyboard.KeyCodes.TWO,
      speedDown: Phaser.Input.Keyboard.KeyCodes.ONE
    }) as PlayerControls;

    this.debugControls = this.scene.input.keyboard.addKeys({
      toggleDebugMovement: Phaser.Input.Keyboard.KeyCodes.T,
      up: Phaser.Input.Keyboard.KeyCodes.W,
      upSecond: Phaser.Input.Keyboard.KeyCodes.UP,
      down: Phaser.Input.Keyboard.KeyCodes.S,
      downSecond: Phaser.Input.Keyboard.KeyCodes.DOWN,
      left: Phaser.Input.Keyboard.KeyCodes.A,
      leftSecond: Phaser.Input.Keyboard.KeyCodes.LEFT,
      right: Phaser.Input.Keyboard.KeyCodes.D,
      rightSecond: Phaser.Input.Keyboard.KeyCodes.RIGHT,
      jumpReset: Phaser.Input.Keyboard.KeyCodes.E,
      autoRun: Phaser.Input.Keyboard.KeyCodes.Q
    }) as DebugPlayerControls;

    this.allowDebugControls = !__IS_PRODUCTION__;
    this.allowDebugMovement = false;

    this.scene.events.on(Phaser.Scenes.Events.UPDATE, this.update, this);

    this.player.on(Phaser.GameObjects.Events.DESTROY, () => {
      this.scene.events.off(Phaser.Scenes.Events.UPDATE, this.update, this);

      this.scene.input.off(Phaser.Input.Events.POINTER_DOWN, this.onPointerDown, this);
      this.scene.input.off(Phaser.Input.Events.POINTER_UP, this.onPointerUp, this);
      this.scene.events.off(PlayerController.events.StartJump, this.onPointerDown, this);
      this.scene.events.off(PlayerController.events.EndJump, this.onPointerUp, this);
      this.scene.events.off(PlayerController.events.Switch, this.player.switchAction, this.player);
    });

    this.scene.input.on(Phaser.Input.Events.POINTER_DOWN, this.onPointerDown, this);
    this.scene.input.on(Phaser.Input.Events.POINTER_UP, this.onPointerUp, this);
    this.scene.events.on(PlayerController.events.StartJump, this.onPointerDown, this);
    this.scene.events.on(PlayerController.events.EndJump, this.onPointerUp, this);
    this.scene.events.on(PlayerController.events.Switch, this.player.switchAction, this.player);
  }

  public update(time: number, delta: number) {
    if (Phaser.Input.Keyboard.JustUp(this.playerControls.switch) || Phaser.Input.Keyboard.JustUp(this.playerControls.switchSecond)) {
      this.player.switchAction();
    }

    // Start Jumping
    if (Phaser.Input.Keyboard.JustDown(this.playerControls.jump) || Phaser.Input.Keyboard.JustDown(this.playerControls.jumpSecond)) {
      this.player.jumpStartAction();
      // Continue Jumping.
    }

    // Stop Jumping.
    if (Phaser.Input.Keyboard.JustUp(this.playerControls.jump) || Phaser.Input.Keyboard.JustUp(this.playerControls.jumpSecond)) {
      this.player.jumpEndAction();
    }

    if (Phaser.Input.Keyboard.JustUp(this.playerControls.speedUp)) {
      // this.onSpeedUp();
    }

    if (Phaser.Input.Keyboard.JustUp(this.playerControls.speedDown)) {
      // this.onSpeedDown();
    }

    if (this.allowDebugControls) {
      if (Phaser.Input.Keyboard.JustDown(this.debugControls.autoRun)) {
        if (this.player.IsMoving) {
          this.player.stopMoving();
        } else {
          this.player.startMoving();
        }
      }

      if (Phaser.Input.Keyboard.JustUp(this.debugControls.toggleDebugMovement)) {
        this.allowDebugMovement = !this.allowDebugMovement;
        (this.player.body as MatterJS.BodyType).ignoreGravity = this.allowDebugMovement;
      }

      if (this.allowDebugMovement) {
        if (this.debugControls.up.isDown || this.debugControls.upSecond.isDown) {
          this.player.y -= 1 * delta;
        }
        if (this.debugControls.down.isDown || this.debugControls.downSecond.isDown) {
          this.player.y += 1 * delta;
        }

        if (this.debugControls.right.isDown || this.debugControls.rightSecond.isDown) {
          this.player.x += 1 * delta;
        }

        if (this.debugControls.left.isDown || this.debugControls.leftSecond.isDown) {
          this.player.x -= 1 * delta;
        }

        if (this.debugControls.jumpReset.isDown) {
          // this.canJump = true;
        }
      }
    }
  }

  protected onPointerDown() {
    this.player.jumpStartAction();
  }

  protected onPointerUp() {
    this.player.jumpEndAction();
  }

  protected onSpeedUp() {
    let newGlobalSpeed = RunSettingsHandler.increaseGlobalSpeed(this.scene, 0.25);
    // this.scene.matter.world.engine.timing.timeScale = newGlobalSpeed;
    // this.scene.matter.world.setGravity(0, 1, 0.002 * newGlobalSpeed);
  }

  protected onSpeedDown() {
    let newGlobalSpeed = RunSettingsHandler.decreaseGlobalSpeed(this.scene, 0.25);
    // this.scene.matter.world.setGravity(0, 1, 0.002 * newGlobalSpeed);
    // this.scene.matter.world.engine.timing.timeScale = newGlobalSpeed;
  }
}
